export default __webpack_public_path__ + "static/media/audio_disconnect.5d315f6c.wav";